"use client";

import React, { createContext, useContext, useState } from "react";

const ListingContext = createContext();

export const useListing = () => {
  const context = useContext(ListingContext);
  if (!context) {
    throw new Error("useListing must be used within a ListingProvider");
  }
  return context;
};

export const ListingProvider = ({ children }) => {
  const [lookUpData, setLookUpData] = useState(null);
  const Setter = (data) => {
    setLookUpData(data)
  };

  return (
    <ListingContext.Provider
      value={{
        lookUpData,
        Setter
      }}
    >
      {children}
    </ListingContext.Provider>
  );
};
